import gsap from 'gsap';
import Swiper from 'swiper';

export default function initItemCards() {
    const components = document.querySelectorAll('.item-cards');

    if (!components.length) return;

    let mm = gsap.matchMedia();

    // Desktop: ScrollTrigger animations
    mm.add("(min-width: 992px)", () => {
        components.forEach((component) => {
            const cards = component.querySelectorAll('.item-card');
            const head = component.querySelector('.item-cards__head');

            if (cards.length === 0) return;

            const tl = gsap.timeline({
                scrollTrigger: {
                    trigger: component,
                    start: 'top 80%',
                    toggleActions: 'play none none none',
                }
            });

            if (component.classList.contains('item-cards--threecols')) {
                tl.to(cards[0], {
                    y: 0,
                    duration: 1.2,
                    ease: 'power3.out'
                }, 0);

                if (cards[1]) {
                    tl.to(cards[1], {
                        y: -120,
                        duration: 1.2,
                        ease: 'power3.out'
                    }, 0.1);
                }

                if (cards[2]) {
                    tl.to(cards[2], {
                        y: -240, // Assuming a pattern based on user's -120 jump
                        duration: 1.2,
                        ease: 'power3.out'
                    }, 0.2);
                }
            }

            if (component.classList.contains('item-cards--twocols')) {
                if (cards[1]) {
                    tl.to(cards[1], {
                        y: 100,
                        duration: 1.2,
                        ease: 'power3.out'
                    }, 0.1);
                }
            }

            // Reveal head
            if (head) {
                tl.to(head, {
                    autoAlpha: 1,
                    duration: 0.8,
                    ease: 'power3.out'
                }, '-=0.5');
            }
        });
    });

    // Mobile: Swiper for item-cards
    mm.add("(max-width: 991px)", () => {
        const swiperEls = document.querySelectorAll('.item-cards--threecols .swiper--item-cards');
        const swipers = [];

        swiperEls.forEach(el => {
            const s = new Swiper(el, {
                slidesPerView: 1.1,
                spaceBetween: 0,
                loop: false,
                pagination: false,
                navigation: false,
            });
            swipers.push(s);
        });

        return () => {
            swipers.forEach(s => s.destroy(true, true));
        };
    });
}
